module.exports = __webpack_public_path__ + "static/media/mindy_clipboard_physician.4db92d9d.png";